/**
 * AuthRefreshReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AuthRefreshReq
 */
export interface AuthRefreshReq {
  /** 刷新令牌 */
  refresh_token: string
}

/**
 * AuthRefreshReq Schema
 */
export const AuthRefreshReqSchema: SchemaDefinition = {
  properties: {
    refresh_token: {
      description: '刷新令牌',
      format: 'string',
      type: 'string',
      label: '刷新令牌',
    },
  },
  required: ['refresh_token'],
  type: 'object',
}
